import React from 'react';
import './formGroup.css';

const FormGroup = props => {
  return (
    <div
      className={`form-group ${
        props.className !== undefined ? props.className : ''
      }`}
    >
      {props.children}
    </div>
  );
};

export default FormGroup;
